module.exports = __webpack_public_path__ + "img/SU2F8.7ffdf610.jpg";